module.exports = __webpack_public_path__ + "img/7.e41dfc6a.png";